import { useParams } from "react-router-dom";
import CaseStudyCategory from "@/pages/CaseStudyCategory";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import { getCaseStudyCategory } from "@/data/caseStudies";

/**
 * Dispatcher for /case-studies/:slug.
 *
 * If the slug matches one of the 10 category taxonomy ids (lighting,
 * furniture, home-decor, glass, ceramics, brass, garden, hotel-projects,
 * private-label, oem-development) the request routes to the CategoryCategory
 * hub page. Otherwise it routes to the long-form CaseStudyDetail page.
 */
export default function CaseStudySlugRouter() {
  const { slug } = useParams();
  const cat = getCaseStudyCategory(slug);
  if (cat) {
    // Remap :slug -> :categoryId for CaseStudyCategory's useParams call.
    return <CaseStudyCategory categoryIdOverride={slug} />;
  }
  return <CaseStudyDetail />;
}
